import { v4 as uuidv4 } from 'uuid'
import { ILot } from 'types/lots'
import { ETenderRequirementType } from 'types/tender/tenderRequirements'
import { DeepPartial } from 'react-hook-form'

export const mapFieldValuesToPayload = (values: DeepPartial<ILot>, lot: ILot) => {
  const lotId = values.id

  const updatedValues = {
    ...values,
    name: values.name ?? '',

    technicalRequirement: {
      ...(values.technicalRequirement || {}),
      id: lot.technicalRequirement?.id ?? uuidv4(),
      lotId,
      technicalRequirementItems:
        values.technicalRequirement?.technicalRequirementItems?.map(
          (item: any, index) => ({
            ...item,
            id:
              lot.technicalRequirement?.technicalRequirementItems?.[index]?.id ??
              uuidv4(),
          })
        ) || [],
    },

    documentRequirements: values.documentRequirements?.map(
      (docReq: any, index: number) => ({
        ...docReq,
        extraInfo: docReq.extraInfo || null,
        id: lot.documentRequirements[index]?.id ?? uuidv4(),
        lotId,
        type:
          index === 0
            ? ETenderRequirementType.GENERAL
            : ETenderRequirementType.SPECIAL,
        documentRequirementItems:
          docReq.documentRequirementItems?.map(
            (docItem: any, itemIndex: number) => ({
              ...docItem,
              id:
                lot.documentRequirements[index]?.documentRequirementItems[itemIndex]
                  ?.id ?? uuidv4(),
            })
          ) || [],
      })
    ),

    procurementRequirement: {
      ...(values.procurementRequirement || {}),
      id: lot.procurementRequirement?.id ?? uuidv4(),
      lotId,
      extraInfo: values.procurementRequirement?.extraInfo || null,
      procurementRequirementItems:
        values?.procurementRequirement?.procurementRequirementItems?.map(
          (procItem: any, index) => ({
            ...procItem,
            id:
              lot.procurementRequirement?.procurementRequirementItems[index]?.id ??
              uuidv4(),
          })
        ),
    },
  }

  return updatedValues
}
